import { useEffect, useState, React } from "react";
import { BrowserRouter, Route, Routes, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useAuthContext } from "../../Hooks/useAuthContext";
import Spinner from "../../Components/Loading/Spinner";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus } from '@fortawesome/free-solid-svg-icons'


export default function ListSuppliers() {
    const { dispatch, user } = useAuthContext();
    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [suppliers, setSuppliers] = useState([]);

    // Load users
    useEffect(() => {
        console.log("loading suppliers...");
       
            axios
              .get(`https://${process.env.REACT_APP_IP}/api/suppliers/`, {
                  headers: { Authorization: `bearer ${user.token}` },
              })
              .then((res) => {
                console.log("Users:", res.data);
                setSuppliers(res.data);
                setLoading(false);
              })
              .catch((err) => {
                  console.log(err);
                  setLoading(false);

                  if (err.response.status === 401) {
                      dispatch({ type: "LOGOUT" })
                      navigate("../")
                  }
              });
          
    }, []);



    return (
        <div className="page">
            <div className="row">
                <div className="col-12">
                    {loading && (<Spinner />)}
                    {!loading && (
                        <>
                        <h1>Suppliers <button className="btn-sm btn-primary" onClick={() => { navigate(`/Suppliers/Create/`) }}><FontAwesomeIcon icon={faPlus} /> Add</button> </h1>

                        <table style={{width: "100%"}}>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Email</th>
                                    <th>Telephone</th>
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {suppliers && (suppliers.map((supplier) => {
                                    return (
                                        <tr key={supplier.id} style={{ cursor: "pointer" }}>
                                            <td onClick={() => { navigate(`/Suppliers/View/${supplier.id}`) }}>{supplier.name}</td>
                                            <td onClick={() => { navigate(`/Suppliers/View/${supplier.id}`) }}>{supplier.email}</td>
                                            <td onClick={() => { navigate(`/Suppliers/View/${supplier.id}`) }}>{supplier.telephone}</td>
                                            <td>
                                                <Link to={`/Suppliers/View/${supplier.id}`} className="btn-sm btn-primary">View</Link>
                                                <Link to={`/Suppliers/Edit/${supplier.id}`} className="btn-sm btn-other">Edit</Link>
                                            </td>
                                        </tr>
                                    )
                                }))}
                            
                            </tbody>
                        </table>
                        </>
                    )}
                </div>
            </div>
        </div>
  )
}
